import { useEffect, useState ,useLayoutEffect} from "react";
import { connect } from 'react-redux';
import styles from './SideBar.module.css';
import NavBar2 from '../NavBar2/NavBar2';
import Spinner from '../Spinner/Spinner';
import * as actions from "../../store/actions/index";
import { NavLink, withRouter } from 'react-router-dom';
import {string_to_slug as slug} from "../../store/utility"


const Sidebar = (props) => {
 
    const [isNavOpen, updateIsNavOpen] = useState(false);
    const [isDesktop, updateIsDesktop] = useState(false);

    useEffect(() => {
        // if (props.categories === null) {
        
                   
        // }
            
        if(props.subcategory){
           
            if(props.shop){ 
                props.fetchShopCategory();
            }else{
                props.onFetchSingleCategory(props.match.params.categoryId)
            }
           
      }else{
        props.fetchCategories();
      }
       
        if (window.innerWidth > 768) {
            updateIsNavOpen(true);
            updateIsDesktop(true);
        }
    }, []) 

    const sidebarScrollHandler = ()=>{
        try{
           alert("Sidebar")
           document.getElementById("test").style.top="85px"
           console.log(document.documentElement.scrollTop)
           if (document.documentElement.scrollTop > 200) {
               document.getElementById("test").style.top="0px"
               if(window.innerWidth < 768){

                   if (isNavOpen === true) {
                       updateIsNavOpen(prevState => false)
                   }
               }
           }
       }catch(error){
          
       }
    }

    useEffect(() => {
        // if (window.innerWidth < 768) {
            const scrollHandler = () => {
                // console.log(document.documentElement.scrollTop)
                document.getElementById("test").style.top="85px"
                if (document.documentElement.scrollTop > 200) {
                    document.getElementById("test").style.top="0px"
                    if(window.innerWidth < 768){

                        if (isNavOpen === true) {
                            updateIsNavOpen(prevState => false)
                        }
                    }
                }
            };
            window.addEventListener('scroll', scrollHandler)

            return () => window.removeEventListener('scroll', scrollHandler)
        // }
    }, [isNavOpen])

   

    const navHandler = () => {
        updateIsNavOpen((prevState) => {
            return !prevState;
        })
    }

    const closeNav = () => {
        //automatically closes nav for mobile on click
        if (isDesktop === false) {
            updateIsNavOpen(false)
        }
    }

    let length = "0px";
    if (isNavOpen === true) {
        length = "200px"; 
        
    }   

    const logicRender = ()=>{
        if(props.subcategory){
            return(props.category?renderCategories():null)
        }else{
            return (props.categories?renderCategories():null)
        }
    }
   
  const renderCategories = ()=>{ 
      let categories = [];
      if(props.subcategory){
            //fetch from single direct category dont filter
          let {categoryName,categoryId,subcategoryId,productType} = props.match.params;
          //let category = props.categories.filter(category=> category.id==categoryId)[0];
          let category = props.category
          
            category.subcategories.map(subcategory=>{
            let subcategoryName = subcategory.name; 
            let respectiveids = `${category.id}/${subcategory.id}`
            // let subcategoryName = subcategory.name;
            let url = null;
            if(props.shop){
                url = ("/shop/"+ slug(subcategoryName)+"/"+ props.categoryType+"/"+respectiveids);
            }else{
                url = ("/category/" +  slug(categoryName) + "/"+ slug(subcategoryName)+"/"+ props.categoryType+"/"+respectiveids);
            }
            
            // console.log(url)
            categories.push(
                <NavLink 
                    // onClick={() => { closeNav(); props.updateCategoryName(_categoryName); }}
                    key={subcategory.id} exact
                    to={url}
                    activeClassName={styles.Active}>
                    {subcategoryName}
                </NavLink>)
          })
         return categories;
      }else{
        
        props.categories.map(category=>{
            let categoryName = category.categoryName;
            let url = null;
            if(!category.subcategories){
                url = "/404"
            }else if(!category.subcategories.length){
                url = "/404"
            }else{
                let sub = category.subcategories[0];
                let respectiveids = `${category.id}/${sub.id}`
                url = ("/category/" +  slug(categoryName) + "/"+ slug(sub.name)+"/"+ props.categoryType+"/"+respectiveids);
            }
            
      
            categories.push(
                <NavLink 
                    // onClick={() => { closeNav(); props.updateCategoryName(_categoryName); }}
                    key={category.id} exact
                    to={url}
                    activeClassName={styles.Active}>
                    {category.categoryName}
                </NavLink>
            )
        })
        return categories;
      }
  }
    return ( 
        <>
            <div className={styles.sidebar} style={{ width: length }} id="test" >
                <span className={styles.closebtn} onClick={() => navHandler()}><i className='fa fa-angle-double-left'></i></span>
                <h6 style={{ marginLeft: "30px", marginTop: "20px" }}>Browse Categories</h6>
                {/* creates categories or shows loading */}
                {props.loading ?
                    <div className={styles.Spinner}><Spinner size="small" /></div>
                    : logicRender()}
            </div>

            {/* provides marginLeft when desktop */}
            {isDesktop === true ?
                <div id={styles.main} style={{ marginLeft: length }}>
                    <NavBar2 navHandler={navHandler} />
                    {props.children}
                </div> :
                <>
                    <NavBar2 navHandler={navHandler} />
                    {props.children}
                </>
            }
        </>
    );
}

const mapStateToProps = state => {
    return {
        categories: state.sidebarCategory.categories,
        category:state.sidebarCategory.category,
        loading: state.sidebarCategory.loading,
        categoryType: state.categoryProducts.categoryType,

    };
};
 
const mapDispatchToProps = dispatch => {
    return {
        fetchCategories: () => dispatch(actions.fetchCategories()),
        onFetchSingleCategory:(categoryId)=>dispatch(actions.fetchSingleCategory(categoryId)),
        fetchShopCategory:()=>dispatch(actions.fetchShopCategory()),
        updateCategoryName: (categoryName) => dispatch(actions.updateCategoryName(categoryName))
    };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Sidebar));